module.exports = __webpack_public_path__ + "static/media/Serial1Logo.ba1fd677.avif";